import $ from 'jquery';
jQuery.noConflict();

export function refreshMiniCart() {
    (function ($) {
        $.ajax({
            type: 'GET',
            url: '/checkout/ajax/miniCart/?limit=100',
            dataType: 'json'
        }).done(function (data) {
            var $miniCart = $('.block-cart .cart-drawer');

            // Update subtotal
            $miniCart.find('.subtotal .price').html('$' + data.subtotal);

            // Update item count text
            var countText = data.items_qty == 1 ? '1 item' : data.items_qty + ' items';
            $miniCart.find('.cart-count .amount').text(countText);

            // Update nav cart icon badge
            $('.minicart-item-count').text(data.items_qty);

            // Update checkout sidebar collapsible dropdown count
            $('.sidebar-items-toggle__count').text(data.items_qty);

            if (typeof data.items !== 'undefined' && data.items.length) {
                var $itemsList = $miniCart.find('#modal-cart-data ol.mini-products-list');
                $itemsList.empty();

                for (var i = 0; i < data.items.length; i++) {
                    try {
                        var item = data.items[i];
                        var $li = '<li class="item">' +
                            '<a href="' + (item.url || '') + '" title="' + item.name + '" class="product-image">' +
                            '<img src="' + item.image_thumbnail + '" width="50" height="50" alt="' + item.name + '">' +
                            '</a>' +
                            '<div class="product-details">' +
                            '<div class="product-details-top">' +
                            '<div class="product-details-top-left">' +
                            '<p class="product-name"><a href="' + (item.url || '') + '">' + item.name + '</a></p>' +
                            '</div>' +
                            '</div>' +
                            '<div class="product-details-bottom">' +
                            '<div class="product-details-bottom-left">' +
                            '<div class="product-qty">Qty: ' + item.qty + '</div>' +
                            '</div>' +
                            '<div class="product-details-bottom-right">' +
                            '<span class="price">$' + item.price + '</span>' +
                            '</div>' +
                            '</div>' +
                            '</div>' +
                            '</li>';

                        $itemsList.append($li);
                    } catch (err) {
                        console.log(err);
                    }
                }
            }       
        });
    })(jQuery);
}